/* ══════════════════════════════════════════════════════════════════════════
   ALIA booking widget — Option P · "Candlelight"  (single widget build)

   Shadow-DOM isolated: none of the CSS below can leak into the theme, and
   none of the theme's CSS can reach in. Renders once, bottom-right.

   Corporate → opens the private-events enquiry form.
   Restaurant → opens OpenTable in a new tab.
   Club      → calls the venue.

   The enquiry form is the one ported from alia-enquiry-form.html. Its field
   design notes are load-bearing, so they travel with it (see FIELDS below).
   Colours are the theme's, not the source file's, and every ratio was
   re-measured against THIS card rather than carried over.

   ── WIRING ────────────────────────────────────────────────────────────────
   Edit CFG below, or override from Liquid *before* this script loads:
     <script>window.ALIA_WIDGET_CONFIG = { corporateEndpoint: "https://..." };</script>
   ═════════════════════════════════════════════════════════════════════════ */
(function () {
  if (document.getElementById('alia-wgt-host')) return;

  var CFG = {
    /* Phone — the club / "call us" action */
    phone: '(514) 566-2542',
    phoneHref: 'tel:+15145662542',

    /* OpenTable — the restaurant / "book a table" action */
    opentableUrl: 'https://www.opentable.ca/r/alia-montreal',


    /* Written to the Source column on every lead. One shared sheet collects
       every site, so this is what tells them apart.

       Leave it EMPTY and the site's own hostname is used. That matters at
       scale: the same snippet can then be pasted into hundreds of sites with
       no per-site edit, and no chance of two of them being given the same
       label by mistake. Set it explicitly only when a friendly name is wanted
       in the sheet, e.g. { source: 'Amber' }. */
    source: '',

    /* Corporate lead form.
       '' (empty)  = DEMO MODE: the enquiry opens a prefilled email in the
                     guest's mail app. That needs no server, but if they
                     never press send in their mail client nobody is
                     contacted — while the confirmation has already promised
                     a reply. This is the one real gap in the form.
       'https://…' = LIVE: POSTs the lead as JSON to that URL. For a Google
                     Apps Script Web App, paste the /exec URL here — the POST
                     is sent no-cors + text/plain so it needs no CORS setup,
                     and Apps Script reads it via e.postData.contents. */
    corporateEndpoint: '',

    replyPromise: 'within one business day',

    /* The theme has its own sticky Reserve/Call dock in the same corner.
       Leave true so the two don't stack on top of each other. */
    hideThemeDock: true,

    /* Hold the widget back until the theme's preloader has finished. */
    waitForPreloader: true
  };

  var over = window.ALIA_WIDGET_CONFIG;
  if (over) { for (var k in over) { if (Object.prototype.hasOwnProperty.call(over, k)) CFG[k] = over[k]; } }

  var CSS = `
  :host{
    --card:#241c14; --card-2:#2c2318;
    --ink:#F4EEE4; --muted:#AC9E8C; --faint:#7C7060;
    --line-2:rgba(244,238,228,.18);
    --green:#34A96B; --green-bright:#46C983; --gold:#CDA05C; --err:#E4694B;
    --green-ink:#08120B;      /* 6.38:1 on --green, 9.03:1 on --green-bright */

    /* form wells — see FIELDS notes */
    --well:#3D3428; --well-hover:#4A4031; --well-focus:#514534;
    --rim:#826B3B;            /* 3.29:1 on --card, the non-text UI minimum */
    --rim-lit:#9C8046;
    --placeholder:#BDB4A2;    /* 5.94:1 on --well */

    /* The theme's faces. @font-face is document-scoped, so the Chivo files
       the templates load are available inside this shadow root — the widget
       just has to ask for them. It was on the OS UI font before, which made
       the card and the form read as a different product from the page.
       Loaded weights: Chivo 300/400/700, Chivo Mono 300/400/500. Asking for
       anything else gets synthetic bold, so nothing below does. */
    --ff:'Chivo',system-ui,-apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;
    --mono:'Chivo Mono',ui-monospace,"SF Mono",Menlo,Consolas,monospace;
    position:fixed; inset:0; z-index:2147483000; pointer-events:none;
    font-family:var(--ff); line-height:1.6;
    opacity:0; transition:opacity .5s ease;
    color-scheme:dark;   /* makes the UA draw a LIGHT date-picker glyph */
  }
  :host([data-ready]){opacity:1}
  *{box-sizing:border-box;margin:0}
  button{font-family:inherit}

  /* The UA rule for [hidden] is only display:none, so ANY author rule that
     sets a display value on the same element silently outranks it and the
     element stays on screen. Guard the whole class of bug once. */
  [hidden]{display:none !important}

  /* ── buttons ─────────────────────────────────────────────────────────── */
  /* Filled green at rest, brightening on hover — same rule as the theme's CTA
     cluster (assets/alia-cta.css). The ghosts stay outlined, so the primary
     still reads as the primary. */
  /* typography matches .acta in assets/alia-cta.css exactly, so the card and
     the page buttons are the same control in two places */
  .cta{position:relative;display:inline-flex;align-items:center;gap:.6rem;border:1.5px solid transparent;cursor:pointer;font-family:var(--mono);text-decoration:none;
    font-weight:500;font-size:.74rem;letter-spacing:.2em;text-transform:uppercase;border-radius:0;overflow:hidden;isolation:isolate;
    transition:color .35s ease,box-shadow .35s ease,border-color .35s ease;color:var(--green-bright)}
  .cta .lab{display:flex;flex-direction:column;line-height:1.22;text-align:left}
  .cta.primary{background:var(--green);color:var(--green-ink);border-color:var(--green);box-shadow:0 8px 22px rgba(52,169,107,.28)}
  /* z-index:-1, NOT 1. At 1 the fill paints over any bare text node — only
     the primary wraps its label in .lab, so both ghosts went blank on hover.
     -1 stays inside the button because .cta sets isolation:isolate. */
  .cta.primary::before{content:"";position:absolute;inset:0;background:var(--green-bright);transform:translateY(101%);transition:transform .44s cubic-bezier(.2,.7,.3,1);z-index:-1}
  .cta.primary:hover{color:var(--green-ink);border-color:var(--green-bright);box-shadow:0 12px 32px rgba(52,169,107,.42)}
  .cta.primary:hover::before{transform:translateY(0)}
  .cta.ghost{background:transparent;color:var(--green-bright);border-color:rgba(52,169,107,.78)}
  .cta.ghost::before{content:"";position:absolute;inset:0;background:var(--green);transform:translateY(101%);transition:transform .44s cubic-bezier(.2,.7,.3,1);z-index:-1}
  .cta.ghost:hover{color:var(--green-ink)}
  .cta.ghost:hover::before{transform:translateY(0)}
  /* same reasoning as the theme's cluster: no hover on a phone, so the fill
     that makes the primary a primary would never show. Fill it at rest there. */
  @media (hover:none){
    .cta.primary:active{background:var(--green-bright);border-color:var(--green-bright)}
    .cta.ghost:active{color:var(--green-ink)}
    .cta.ghost:active::before{transform:translateY(0)}
  }
  .cta[disabled]{opacity:.6;cursor:progress}
  .cta:focus-visible{outline:2px solid var(--gold);outline-offset:2px}
  @keyframes rise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}

  /* ── P · Candlelight ─────────────────────────────────────────────────── */
  .w-candle{position:absolute;right:1.6rem;bottom:1.6rem;display:flex;flex-direction:column;align-items:flex-end;gap:.7rem;pointer-events:auto}
  /* the ask button — outlined at rest like every other control, filling green
     on hover. The pulsing ring is what keeps it findable without a fill. */
  .help-btn{position:relative;width:62px;height:62px;border-radius:50%;background:var(--green);
    border:2px solid var(--green-bright);cursor:pointer;display:grid;place-items:center;
    box-shadow:0 12px 30px rgba(0,0,0,.5),0 6px 22px rgba(52,169,107,.22);
    transition:background .3s ease,transform .3s ease,box-shadow .3s ease}
  .help-btn:hover{background:var(--green-bright);transform:translateY(-2px);box-shadow:0 12px 30px rgba(0,0,0,.5),0 8px 26px rgba(52,169,107,.45)}
  .help-btn:hover .qm{color:var(--green-ink)}
  .help-btn:focus-visible{outline:2px solid var(--gold);outline-offset:3px}
  .help-btn .qm{font-family:var(--ff);font-size:1.65rem;font-weight:700;line-height:1;color:var(--green-ink);transition:color .3s ease}
  .help-btn .ring{position:absolute;inset:-7px;border-radius:50%;border:1.5px solid rgba(70,201,131,.6);
    animation:halo 2.8s ease-out infinite;pointer-events:none}
  @keyframes halo{0%{transform:scale(.9);opacity:.85}70%{transform:scale(1.25);opacity:0}100%{opacity:0}}
  .w-candle.open .help-btn .ring{animation:none;opacity:0}
  .candle-card{display:none;flex-direction:column;gap:.5rem;width:min(250px,76vw);background:var(--card);border:1px solid rgba(226,199,142,.25);border-radius:0;padding:1rem;box-shadow:0 18px 44px rgba(0,0,0,.6);color:var(--ink)}
  .candle-card .cc-t{font-weight:300;font-size:1.05rem;text-transform:uppercase;letter-spacing:.03em;line-height:1.05}
  .candle-card .cc-s{font-size:.7rem;color:var(--muted);margin-bottom:.3rem}
  .w-candle.open .candle-card{display:flex;animation:rise .25s ease}
  .candle-card .cta{justify-content:flex-start;padding:.6rem .8rem;font-size:.74rem}

  /* ══ enquiry modal ═══════════════════════════════════════════════════════
     The design from the boss's alia-enquiry-form.html, restored. Its palette,
     its type, its rounded corners — all scoped to .modal, so the candle card,
     the "?" button and the site-wide CTA cluster keep the squared, Chivo,
     outlined-green treatment they were given separately.

     Its own field notes travel with it, because they are load-bearing:
       · The well is LIGHTER than the card. Darker read as a hole rather than
         a place to type.
       · Placeholder #BDB4A2 is 5.94:1 on the well.
       · The brass rim carries the control boundary at 3.24:1 — which only
         holds because the card is back to #17140F. Against the widget's
         lighter #241c14 the same rim measured 2.96:1 and missed the minimum.
       · State lives on the .field WRAPPER, so every rule sits at one
         specificity tier and the order below IS the priority order.
       · Values are 16px. Below that, iOS zooms the page on focus.
     ═══════════════════════════════════════════════════════════════════════ */
  .scrim{position:fixed;inset:0;background:rgba(8,6,4,.74);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;padding:1.2rem;z-index:900;pointer-events:auto;overflow-y:auto}
  .scrim.on{display:flex}

  .modal{
    /* the source file's tokens, kept local to the modal */
    --m-night:#100E0A; --m-card:#17140F; --m-hair:#2A241A;
    --m-cream:#F3EEE1; --m-dim:#A79E8C;
    --m-brass:#C9A45C; --m-rim:#7A6437; --m-rim-lit:#9C8046;
    --m-well:#3D3428; --m-well-hover:#4A4031; --m-well-focus:#514534;
    --m-ph:#BDB4A2;
    --m-jade:#34A96B; --m-jade-lit:#46C983; --m-jade-ink:#04210F;
    --m-err:#C4713F; --m-err-lit:#E0705E;
    --m-sans:ui-sans-serif,-apple-system,BlinkMacSystemFont,"Helvetica Neue","Segoe UI",Roboto,Arial,sans-serif;
    --m-mono:ui-monospace,SFMono-Regular,"SF Mono",Menlo,"Cascadia Mono",Consolas,monospace;

    position:relative;display:flex;flex-direction:column;width:min(660px,100%);
    max-height:94vh;max-height:min(94svh,900px);
    background:var(--m-card);color:var(--m-cream);
    font-family:var(--m-sans);line-height:1.6;
    border:1px solid var(--m-hair);border-top:2px solid var(--m-jade);
    border-radius:5px;animation:rise .25s ease;margin:auto;
    scrollbar-color:var(--m-rim) var(--m-card);
  }
  .modal :focus-visible{outline:2px solid var(--m-jade-lit);outline-offset:3px;border-radius:3px}
  .modal ::selection{background:var(--m-jade);color:var(--m-jade-ink)}

  .m-head{flex:none;display:flex;justify-content:space-between;align-items:flex-start;gap:1.2rem;
    padding:20px 28px 16px;border-bottom:1px solid var(--m-hair)}
  .m-eye{font-family:var(--m-mono);font-size:11px;letter-spacing:.28em;text-transform:uppercase;color:var(--m-brass);margin:0}
  .modal h3{font-family:var(--m-sans);font-size:1.6rem;font-weight:300;text-transform:none;letter-spacing:-.02em;margin:6px 0;line-height:1.15}
  .modal p.m-sub{margin:0;font-size:14px;color:var(--m-dim);max-width:46ch}
  .m-close{flex:none;width:34px;height:34px;border-radius:3px;background:transparent;border:1px solid var(--m-hair);
    color:var(--m-dim);font-size:17px;line-height:1;cursor:pointer;transition:color .15s ease,border-color .15s ease}
  .m-close:hover{color:var(--m-cream);border-color:var(--m-rim)}

  .m-body{flex:1 1 auto;min-height:0;display:flex;flex-direction:column;overflow:hidden}
  .m-body form{flex:1 1 auto;min-height:0;display:flex;flex-direction:column}
  .m-scroll{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:20px 28px 12px}

  /* ── fields ─────────────────────────────────────────────────────────── */
  .m-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
  .m-span2{grid-column:1 / -1}
  .field{display:flex;flex-direction:column;gap:6px;min-width:0;position:relative}
  .field > label{font-family:var(--m-mono);font-size:10.5px;letter-spacing:.2em;text-transform:uppercase;color:var(--m-brass)}
  .field .opt{color:var(--m-rim)}

  .field input,.field select,.field textarea{
    font-family:var(--m-sans);font-size:16px;color:var(--m-cream);background:var(--m-well);
    border:0;border-radius:4px;padding:11px 14px;width:100%;
    box-shadow:inset 0 0 0 1px var(--m-rim),inset 0 1px 0 var(--m-rim-lit),
               0 1px 0 rgba(0,0,0,.5),0 4px 12px -6px rgba(0,0,0,.7);
    transition:background .16s ease,box-shadow .16s ease}
  .field textarea{resize:vertical;min-height:68px;font-size:15px;line-height:1.55}
  .field input::placeholder,.field textarea::placeholder{color:var(--m-ph);opacity:1}

  .field input:hover,.field select:hover,.field textarea:hover{
    background:var(--m-well-hover);
    box-shadow:inset 0 0 0 1px var(--m-rim-lit),inset 0 1px 0 #B08F4E,
               0 1px 0 rgba(0,0,0,.5),0 4px 12px -6px rgba(0,0,0,.7)}
  .field input:focus,.field select:focus,.field textarea:focus{
    outline:none;background:var(--m-well-focus);
    box-shadow:inset 0 0 0 2px var(--m-jade-lit),0 0 0 4px rgba(52,169,107,.16)}

  /* filled stands down for invalid, or a malformed email that is also focused
     would wear the success ring while wrong */
  .field.is-filled:not(.is-invalid) input,
  .field.is-filled:not(.is-invalid) select,
  .field.is-filled:not(.is-invalid) textarea{
    box-shadow:inset 4px 0 0 var(--m-jade),inset 0 0 0 1px var(--m-rim),
               inset 0 1px 0 var(--m-rim-lit),0 1px 0 rgba(0,0,0,.5)}
  .field.is-filled:not(.is-invalid) input:focus,
  .field.is-filled:not(.is-invalid) select:focus,
  .field.is-filled:not(.is-invalid) textarea:focus{
    box-shadow:inset 4px 0 0 var(--m-jade),inset 0 0 0 2px var(--m-jade-lit),
               0 0 0 4px rgba(52,169,107,.16)}

  .field.is-invalid input,.field.is-invalid select,.field.is-invalid textarea{
    box-shadow:inset 4px 0 0 var(--m-err),inset 0 0 0 1px #B4523C,0 1px 0 rgba(0,0,0,.5)}
  .field.is-invalid input:focus,.field.is-invalid select:focus,.field.is-invalid textarea:focus{
    box-shadow:inset 4px 0 0 var(--m-err),inset 0 0 0 2px var(--m-err),0 0 0 4px rgba(196,113,63,.18)}
  /* The error rides on the LABEL line, out of flow. In flow it added a row to
     every field that failed — seven required fields meant the form could grow
     ~140px the instant someone pressed Send, which is what put the scrollbar
     back. Out of flow, a failing form is exactly as tall as a passing one. */
  .field .err{position:absolute;top:0;right:0;display:none;
    font-family:var(--m-mono);font-size:10.5px;line-height:1.6;letter-spacing:.1em;
    color:var(--m-err-lit);text-transform:uppercase;pointer-events:none}
  .field.is-invalid .err{display:block}
  .field > label{padding-right:5.5em}   /* keep the label clear of it */

  /* an EMPTY date input paints its yyyy-mm-dd hint in the full text colour,
     making the one blank required field read as the most complete */
  .field:not(.is-filled) input[type="date"]{color:var(--m-ph)}
  .field input[type="number"]{-moz-appearance:textfield;appearance:textfield}
  .field input[type="number"]::-webkit-outer-spin-button,
  .field input[type="number"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
  .field select{appearance:none;cursor:pointer;padding-right:34px}
  .select-wrap{position:relative}
  .select-wrap::after{content:"⌄";position:absolute;right:13px;top:10px;color:var(--m-brass);pointer-events:none;font-size:12px}
  .ev-back{align-self:flex-start;background:none;border:0;padding:0;cursor:pointer;
    font-family:var(--m-mono);font-size:10px;letter-spacing:.14em;text-transform:uppercase;
    color:var(--m-rim);transition:color .2s ease}
  .ev-back:hover{color:var(--m-jade-lit)}

  /* Chrome paints autofill with its own background unless a large inset shadow
     covers it, and box-shadow paints the FIRST layer on top, so the covering
     fill has to be the last one */
  .field input:-webkit-autofill{
    -webkit-text-fill-color:var(--m-cream);
    transition:background-color 8000s ease-in-out 0s;
    -webkit-box-shadow:inset 0 0 0 1px var(--m-rim),inset 0 1px 0 var(--m-rim-lit),
                       inset 0 0 0 100px var(--m-well)}

  /* ── footer ─────────────────────────────────────────────────────────── */
  .m-foot{flex:none;display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;
    padding:14px 28px 18px;border-top:1px solid var(--m-hair);background:var(--m-card)}
  .m-foot p{margin:0;font-size:12.5px;color:var(--m-dim);max-width:34ch}
  .modal .note{margin:4px 0 0;font-size:11.5px;color:var(--m-rim);max-width:36ch}
  .modal .err-top{display:none;font-size:12.5px;color:var(--m-err-lit);margin-top:10px;text-align:center}
  .modal .err-top.on{display:block}

  /* the buttons, back to the source file's .btn — flat jade fill, no wipe */
  .modal .cta.primary{
    font-family:var(--m-mono);font-size:11.5px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;
    border-radius:4px;padding:12px 18px;flex:none;
    border:1px solid var(--m-jade);background:var(--m-jade);color:var(--m-jade-ink);
    box-shadow:none;transition:background .16s ease,box-shadow .2s ease,transform .16s ease}
  .modal .cta.primary::before{content:none}
  .modal .cta.primary:hover{background:var(--m-jade-lit);border-color:var(--m-jade-lit);color:var(--m-jade-ink);box-shadow:0 6px 26px -8px rgba(52,169,107,.8)}
  .modal .cta.primary:active{transform:translateY(1px)}
  .modal .cta.ghost{
    font-family:var(--m-mono);font-size:11.5px;font-weight:400;letter-spacing:.16em;text-transform:uppercase;
    border-radius:4px;padding:12px 18px;
    background:transparent;color:var(--m-jade-lit);border:1px solid #1D5F3D}
  .modal .cta.ghost::before{content:none}
  .modal .cta.ghost:hover{background:rgba(52,169,107,.1);border-color:var(--m-jade);color:var(--m-jade-lit);box-shadow:none}

  /* shadow DOM blocks the theme's rules but not INHERITANCE, and
     scrollbar-color is inherited — without this the page's parchment track
     arrives through the host element */
  .m-scroll::-webkit-scrollbar,.scrim::-webkit-scrollbar{width:10px;height:10px}
  .m-scroll::-webkit-scrollbar-track,.scrim::-webkit-scrollbar-track{background:var(--m-card)}
  .m-scroll::-webkit-scrollbar-thumb,.scrim::-webkit-scrollbar-thumb{
    background:var(--m-rim);border:2px solid var(--m-card);border-radius:5px}
  .m-scroll::-webkit-scrollbar-thumb:hover,.scrim::-webkit-scrollbar-thumb:hover{background:var(--m-rim-lit)}

  /* The confirmation never paints a bar, on any device. It is a read-back of
     what was just typed, not something to work through, and a bar down the
     side of a "thank you" reads as an error. overflow stays auto rather than
     hidden so nothing can become UNREACHABLE on a very short window — the
     layout below is sized so it does not come to that. */
  .done{scrollbar-width:none}
  .done::-webkit-scrollbar{width:0;height:0}

  /* TOUCH: no visible bar.
     Styling ::-webkit-scrollbar at a fixed width forces a permanent, space-
     taking bar — on a phone that is a stripe down the side of the form for no
     benefit. A pointer device needs the bar as the affordance for dragging; a
     finger scrolls the content directly, so there is nothing to give up. */
  @media (hover:none){
    .modal{scrollbar-width:none}
    .m-scroll,.scrim{scrollbar-width:none}
    .m-scroll::-webkit-scrollbar,.scrim::-webkit-scrollbar{width:0;height:0}
  }

  /* ══ SHORT WINDOWS ═══════════════════════════════════════════════════════
     The spacing above is what the design wants when there is room. Below about
     800px of viewport the nine fields no longer fit, and the choice is to
     compress or to scroll. Compress: a scrollbar in a form this short reads as
     broken, and hiding the bar while still scrolling would only hide the
     fields rather than fix anything.
     Nothing here changes a colour, a typeface or a corner — only spacing, and
     the field text stays at 16px because anything smaller makes iOS zoom the
     page the moment a field is tapped. */
  @media (max-height:800px){
    .m-head{padding:14px 28px 11px}
    .modal h3{font-size:1.35rem;margin:3px 0}
    .modal p.m-sub{font-size:13px;max-width:52ch}
    .m-scroll{padding:14px 28px 8px}
    .m-grid{gap:10px}
    .field{gap:4px}
    .field > label{font-size:10px;letter-spacing:.18em}
    .field input,.field select,.field textarea{padding:9px 13px}
    .field textarea{min-height:52px}
    .select-wrap::after{top:7px}
    /* one line each instead of two — the footer was the tallest fixed block */
    .m-foot{padding:10px 28px 12px}
    .m-foot p{font-size:12px;max-width:none}
    .modal .note{font-size:11px;max-width:none;margin-top:2px}
    .modal .cta.primary{padding:10px 16px}
  }
  /* smaller again for netbook-class heights */
  @media (max-height:620px){
    .m-head{padding:11px 28px 9px}
    .modal h3{font-size:1.2rem}
    .modal p.m-sub{font-size:12px}
    .m-grid{gap:8px}
    .field input,.field select,.field textarea{padding:8px 12px}
    .field textarea{min-height:44px}
    .modal .note{display:none}   /* the one line that is supplementary */
  }

  /* ── confirmation ───────────────────────────────────────────────────── */
  .done{flex:1 1 auto;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:16px;padding:24px 28px 28px}
  /* Children of a column flex box shrink by default. .summary carries
     overflow:hidden for its rounded corners, so when the confirmation is
     taller than the modal it was shrinking and CLIPPING its own rows rather
     than letting .done scroll — the later fields simply could not be reached
     on a phone. Nothing in here shrinks; .done scrolls instead. */
  .done > *{flex-shrink:0}
  .done-mark{width:46px;height:46px;border-radius:50%;background:var(--m-jade);color:var(--m-jade-ink);
    display:grid;place-items:center;font-size:22px;font-weight:700}
  .done-h{font-family:var(--m-sans);font-size:1.7rem;font-weight:300;text-transform:none;letter-spacing:-.02em;margin:0 0 10px;line-height:1.1}
  .done-lede{margin:0;color:var(--m-dim);font-size:15px;max-width:48ch}
  .done-lede b{color:var(--m-cream);font-weight:700}
  .summary{display:grid;gap:1px;background:var(--m-hair);border:1px solid var(--m-hair);border-radius:3px;overflow:hidden;margin:0}
  .summary > div{background:var(--m-night);padding:11px 15px;display:flex;justify-content:space-between;gap:18px;font-size:13.5px}
  .summary dt{font-family:var(--m-mono);font-size:10.5px;letter-spacing:.18em;text-transform:uppercase;color:var(--m-brass)}
  .summary dd{margin:0;text-align:right;color:var(--m-cream)}
  .done-next{border-top:1px solid var(--m-hair);padding-top:18px;display:flex;flex-direction:column;gap:12px}
  .done-actions{display:flex;gap:10px;flex-wrap:wrap}
  .done-fine{margin:0;font-size:12.5px;color:var(--m-rim);max-width:52ch}

  /* ── keeping the confirmation on one screen ──
     The summary is up to nine rows. Stacked, that alone is taller than most
     laptop windows, which is what put a scrollbar down the side of a "thank
     you". Two columns makes it five rows, and the whole panel fits. */
  @media(min-width:601px){
    .summary{grid-template-columns:1fr 1fr}
    /* an odd final row would leave a hairline-coloured hole in the grid */
    .summary > div:last-child:nth-child(odd){grid-column:1 / -1}
    /* 48ch inside a 604px panel wrapped this to six lines and pushed the last
       line of the panel past its own bottom padding. The panel is wide enough
       to carry a longer measure without hurting the read. */
    .done-lede{max-width:62ch}
  }
  /* Short windows: trim the parts that are reassurance rather than content,
     in order of how little they carry. */
  @media (max-height:800px){
    .done{padding:16px 28px 20px;gap:12px}
    .done-mark{width:38px;height:38px;font-size:18px}
    .done-h{font-size:1.4rem;margin:0 0 6px}
    .done-lede{font-size:14px}
    .summary > div{padding:8px 15px;font-size:13px}
    .done-next{padding-top:13px;gap:10px}
  }
  @media (max-height:620px){
    .done{gap:9px}
    .done-mark{display:none}      /* the heading already says it went through */
    .done-h{font-size:1.2rem}
    .done-lede{font-size:13px}
    .summary > div{padding:6px 13px;font-size:12.5px}
    .done-fine{display:none}      /* supplementary, same call as .note above */
  }
  .toast{position:fixed;left:50%;bottom:1.6rem;transform:translateX(-50%) translateY(20px);background:var(--card);border:1px solid var(--line-2);border-radius:0;padding:.8rem 1.2rem;font-size:.9rem;color:var(--ink);opacity:0;pointer-events:none;transition:opacity .25s,transform .25s;z-index:800;max-width:min(360px,88vw);text-align:center}
  .toast.on{opacity:1;transform:translateX(-50%) translateY(0)}
  .toast b{color:var(--green-bright)}

  @media(max-width:600px){
    .w-candle{right:1rem;bottom:1rem}
    .m-grid{grid-template-columns:1fr}
    .m-head{padding:1.1rem 1.2rem .9rem}
    .m-scroll{padding:1.1rem 1.2rem 0.9rem}
    .m-foot{padding:0.9rem 1.2rem 1.1rem}
    .done{padding:1.1rem 1.2rem 1.3rem;gap:12px}
    .modal h3{font-size:1.35rem}
    /* Tighter rows so most confirmations fit without scrolling at all —
       scrolling now works, but not needing it is better. */
    .summary > div{padding:8px 12px;font-size:12.5px;gap:12px}
    .done-h{font-size:1.45rem;margin:0 0 7px}
    .done-lede{font-size:14px}
    .done-next{padding-top:13px;gap:10px}
    .done-actions{gap:8px}
    .done-actions .cta{width:100%;justify-content:center}
  }
  @media(prefers-reduced-motion:reduce){*{animation:none!important;transition:none!important}}
  `;

  var HTML = `
  <div class="w-candle" data-candle>
    <div class="candle-card">
      <p class="cc-t">How can we help?</p>
      <p class="cc-s">Three ways in — pick one.</p>
      <button class="cta primary" data-act="corp"><span class="lab">Corporate · Private events</span></button>
      <button class="cta ghost" data-act="rest">Restaurant · Book</button>
      <button class="cta ghost" data-act="club">Club · Call</button>
    </div>
    <button class="help-btn" data-trigger aria-expanded="false" aria-label="How can we help — book a table or plan a private event"><span class="ring"></span><span class="qm">?</span></button>
  </div>

  <div class="scrim" data-scrim>
    <div class="modal" data-modal role="dialog" aria-modal="true" aria-labelledby="alia-m-title">
      <div class="m-head">
        <div>
          <p class="m-eye">Private events</p>
          <h3 id="alia-m-title" data-mtitle>Request a date</h3>
          <p class="m-sub" data-msub>We answer the same day, with availability and a starting menu.</p>
        </div>
        <button type="button" class="m-close" data-mclose aria-label="Close">✕</button>
      </div>

      <div class="m-body">
        <!-- novalidate: we run checkValidity() ourselves so the error styling
             and the browser's own validity stay in step, and we control the
             wording. -->
        <form data-form novalidate>
          <div class="m-scroll">
          <div class="m-grid">
            <div class="field">
              <label for="alia-f-name">Your name</label>
              <input id="alia-f-name" name="Name" type="text" autocomplete="name" required>
              <span class="err">Required</span>
            </div>
            <div class="field">
              <label for="alia-f-company">Company</label>
              <input id="alia-f-company" name="Company" type="text" autocomplete="organization" required>
              <span class="err">Required</span>
            </div>
            <div class="field">
              <label for="alia-f-email">Work email</label>
              <input id="alia-f-email" name="Email" type="email" autocomplete="email" required>
              <span class="err">Enter a valid email</span>
            </div>
            <div class="field">
              <label for="alia-f-phone">Phone</label>
              <input id="alia-f-phone" name="Phone" type="tel" autocomplete="tel" required>
              <span class="err">Required</span>
            </div>
            <div class="field">
              <label for="alia-f-event" data-ev-label>Event</label>
              <div class="select-wrap" data-ev-list>
                <!-- the placeholder option MUST carry value="" so an untouched
                     select reports as empty rather than as an answer -->
                <select id="alia-f-event" name="Event" required>
                  <option value="" selected>Choose one</option>
                  <option>Year-end party</option>
                  <option>Client dinner</option>
                  <option>Full buyout</option>
                  <option>Cocktail reception</option>
                  <option>Product launch</option>
                  <option>Something else</option>
                </select>
              </div>
              <!-- "Something else" swaps the select for this input IN PLACE —
                   same box, same slot, no second field. Both carry name="Event"
                   and whichever is inactive is disabled, so exactly one value
                   is ever submitted and the payload keeps one Event column.
                   (Disabled controls are skipped by form.elements collection
                   and by checkValidity, which is what makes the swap safe.) -->
              <input id="alia-f-event-other" name="Event" type="text" data-ev-other hidden disabled>
              <button type="button" class="ev-back" data-ev-back hidden>&#8592; pick from the list</button>
              <span class="err">Required</span>
            </div>
            <div class="field">
              <label for="alia-f-guests">Guests</label>
              <input id="alia-f-guests" name="Guests" type="number" min="1" max="400" inputmode="numeric" required>
              <span class="err">Required</span>
            </div>
            <div class="field">
              <label for="alia-f-date">Preferred date</label>
              <input id="alia-f-date" name="Date" type="date" required>
              <span class="err">Required</span>
            </div>
            <div class="field">
              <label for="alia-f-budget">Budget per head <span class="opt">(optional)</span></label>
              <div class="select-wrap">
                <select id="alia-f-budget" name="Budget">
                  <option value="" selected>Not sure yet</option>
                  <option>$95 to $150</option>
                  <option>$150 to $225</option>
                  <option>$225 and up</option>
                </select>
              </div>
            </div>
            <div class="field m-span2">
              <label for="alia-f-notes">Anything we should know <span class="opt">(optional)</span></label>
              <textarea id="alia-f-notes" name="Notes"></textarea>
            </div>
          </div>

            <p class="err-top" data-merr></p>
          </div>

          <div class="m-foot">
            <div>
              <p>We hold provisional dates for 48 hours, no deposit.</p>
              <p class="note" data-mnote></p>
            </div>
            <button type="submit" class="cta primary" data-msubmit><span class="lab">Send request</span></button>
          </div>
        </form>

        <div class="done" data-done hidden aria-live="polite">
          <div class="done-mark" aria-hidden="true">✓</div>
          <div>
            <h3 class="done-h" data-dtitle>Thank you.</h3>
            <p class="done-lede" data-dlede></p>
          </div>
          <dl class="summary" data-dsummary></dl>
          <div class="done-next">
            <p class="m-eye">If you need us sooner</p>
            <div class="done-actions">
              <a class="cta ghost" data-dtel>Call the events line</a>
            </div>
            <p class="done-fine" data-dfine></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="toast" data-toast role="status" aria-live="polite"></div>
  `;

  var host = document.createElement('div');
  host.id = 'alia-wgt-host';
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: 'open' });
  root.innerHTML = '<style>' + CSS + '</style>' + HTML;

  if (CFG.hideThemeDock) {
    var hide = document.createElement('style');
    hide.textContent = '.alia-cta-dock{display:none!important}';
    document.head.appendChild(hide);
  }

  var candle = root.querySelector('[data-candle]');
  var trigger = root.querySelector('[data-trigger]');
  var scrim = root.querySelector('[data-scrim]');
  var modal = root.querySelector('[data-modal]');
  var form = root.querySelector('[data-form]');
  var doneEl = root.querySelector('[data-done]');
  var summaryEl = root.querySelector('[data-dsummary]');
  var submit = root.querySelector('[data-msubmit]');
  var errEl = root.querySelector('[data-merr]');
  var noteEl = root.querySelector('[data-mnote]');
  var toast = root.querySelector('[data-toast]');
  var demo = !CFG.corporateEndpoint;

  noteEl.textContent = demo
    ? 'This opens a prefilled email in your mail app — please press send there.'
    : '';
  root.querySelector('[data-dtel]').setAttribute('href', CFG.phoneHref);

  /* ── toast ───────────────────────────────────────────────────────────── */
  var tTimer;
  function showToast(html) {
    toast.innerHTML = html;
    toast.classList.add('on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  }

  /* ── open / close the card ───────────────────────────────────────────── */
  function setOpen(on) {
    candle.classList.toggle('open', on);
    trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  trigger.addEventListener('click', function () { setOpen(!candle.classList.contains('open')); });
  document.addEventListener('click', function (e) {
    if (!candle.classList.contains('open')) return;
    if (e.composedPath().indexOf(candle) === -1) setOpen(false);
  });

  /* ── the three actions ───────────────────────────────────────────────── */

  /* Hold the page still behind the modal. overflow:hidden alone is not enough
     here: the theme drives scrolling with Lenis, which listens on wheel/touch
     and moves the page with a transform, so it happily keeps scrolling a body
     that CSS has locked. Lenis has to be stopped as well. */
  var scrollLocked = false;
  function lockScroll(on) {
    if (on === scrollLocked) return;
    scrollLocked = on;
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
    var l = window.__lenis;
    if (l) { if (on) { if (l.stop) l.stop(); } else if (l.start) l.start(); }
  }

  var lastFocus = null;
  function openModal() {
    lastFocus = root.activeElement;
    /* a second enquiry must not open onto the previous one's confirmation */
    form.hidden = false;
    doneEl.hidden = true;
    root.querySelector('[data-mtitle]').textContent = 'Request a date';
    root.querySelector('[data-msub]').textContent = 'We answer the same day, with availability and a starting menu.';
    scrim.classList.add('on');
    lockScroll(true);
    errEl.classList.remove('on');
    setTimeout(function () { root.getElementById('alia-f-name').focus(); }, 30);
  }
  function closeModal() {
    scrim.classList.remove('on');
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var a = b.getAttribute('data-act');
    if (a === 'corp') {
      openModal();
    } else if (a === 'club') {
      showToast('<b>Calling</b> ' + CFG.phone);
      window.location.href = CFG.phoneHref;
    } else if (a === 'rest') {
      window.open(CFG.opentableUrl, '_blank', 'noopener');
      setOpen(false);
    }
  });

  root.querySelector('[data-mclose]').addEventListener('click', closeModal);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (scrim.classList.contains('on')) closeModal();
    else setOpen(false);
  });

  /* keep Tab inside the modal while it is open */
  scrim.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = [].slice.call(modal.querySelectorAll('button, [href], input, select, textarea'))
      .filter(function (el) { return !el.disabled && !el.closest('[hidden]'); });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = root.activeElement;
    if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  });

  /* ── public API + in-page CTA rows ───────────────────────────────────────
     The theme's CTA cluster (snippets/alia-cta-row.liquid) marks its primary
     button with data-alia-act="corp". Catch those clicks here so an in-page
     row opens the same enquiry form as the candle. The buttons ship as real
     tel:/OpenTable links, so if this script never loads they still work —
     that's why the handler only intercepts "corp".                           */
  window.ALIA = window.ALIA || {};
  window.ALIA.openCorporate = function () { reveal(); setOpen(false); openModal(); };
  window.ALIA.book = function () { window.open(CFG.opentableUrl, '_blank', 'noopener'); };
  window.ALIA.call = function () { window.location.href = CFG.phoneHref; };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[data-alia-act="corp"]')) return;
    e.preventDefault();
    window.ALIA.openCorporate();
  });

  /* ── field state ─────────────────────────────────────────────────────────
     State is written on the .field WRAPPER rather than read from competing
     pseudo-classes on the control. That keeps every CSS rule at one
     specificity tier, and it sidesteps :placeholder-shown, which never
     reports a date input or an unchosen <select> as empty. */
  var fields = [].slice.call(form.querySelectorAll('.field'));
  /* the Event field holds two controls, one of them disabled — always report
     the live one, or the wrapper's filled/invalid state tracks the wrong twin */
  function control(f) {
    var list = f.querySelectorAll('input, select, textarea');
    for (var i = 0; i < list.length; i++) { if (!list[i].disabled) return list[i]; }
    return list[0] || null;
  }

  function syncField(f) {
    var c = control(f);
    if (!c) return;
    f.classList.toggle('is-filled', String(c.value || '').trim() !== '');
    if (f.dataset.touched === '1') {
      var ok = c.checkValidity();
      f.classList.toggle('is-invalid', !ok);
      c.setAttribute('aria-invalid', String(!ok));
    }
  }
  function syncAll() { fields.forEach(syncField); }

  fields.forEach(function (f) {
    var c = control(f);
    if (!c) return;
    c.addEventListener('input', function () { syncField(f); });
    c.addEventListener('change', function () { syncField(f); });
    c.addEventListener('blur', function () { f.dataset.touched = '1'; syncField(f); });
  });
  syncAll();

  /* ── "Something else" ───────────────────────────────────────────────────
     Picking it turns the Event box itself into a text field. One box, one
     value — without this the events team receives a lead whose event type is
     the word "Something else", which tells them nothing.

     disabled, not just hidden: a required control that is display:none still
     fails form.checkValidity(), and the browser cannot focus it to say why, so
     the form would refuse to submit with nothing on screen explaining it.
     Disabling also keeps the inactive twin out of form.elements collection, so
     the two name="Event" controls never both contribute a value. */
  var evSel   = root.getElementById('alia-f-event');
  var evList  = root.querySelector('[data-ev-list]');
  var evOther = root.querySelector('[data-ev-other]');
  var evBack  = root.querySelector('[data-ev-back]');
  var evLabel = root.querySelector('[data-ev-label]');
  var evField = evSel.closest('.field');

  function setEventMode(freeText, moveFocus) {
    evList.hidden    = freeText;
    evSel.disabled   = freeText;
    evOther.hidden   = !freeText;
    evOther.disabled = !freeText;
    evOther.required = freeText;
    evBack.hidden    = !freeText;
    evLabel.setAttribute('for', freeText ? 'alia-f-event-other' : 'alia-f-event');
    if (freeText && moveFocus) evOther.focus();
  }

  evSel.addEventListener('change', function () {
    if (evSel.value === 'Something else') setEventMode(true, true);
  });

  evBack.addEventListener('click', function () {
    evOther.value = '';
    evSel.value = '';
    setEventMode(false, false);
    evField.classList.remove('is-invalid', 'is-filled');
    evField.dataset.touched = '';
    evSel.focus();
  });

  setEventMode(false, false);

  /* a date in the past helps nobody */
  root.getElementById('alia-f-date').min = new Date().toISOString().slice(0, 10);

  /* the date is stored ISO but read back the way a person says it out loud */
  function niceDate(iso) {
    try {
      var p = String(iso).split('-');
      return new Date(p[0], p[1] - 1, p[2]).toLocaleDateString('en-CA',
        { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    } catch (err) { return iso; }
  }

  function collect() {
    var raw = {}, lines = [];
    summaryEl.innerHTML = '';
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || !el.value || el.disabled) return;   /* skip the inactive Event twin */
      var shown = el.name === 'Date' ? niceDate(el.value) : el.value;
      raw[el.name] = el.value;
      var row = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = el.name;
      var dd = document.createElement('dd'); dd.textContent = shown;
      row.appendChild(dt); row.appendChild(dd);
      summaryEl.appendChild(row);
      lines.push(el.name + ': ' + shown);
    });

    /* The keys below are the SHEET's column headers, spaces and all, so the
       Apps Script can map straight across without a translation table. The
       form's own field names stay as they are — they drive the labels, the
       summary above and validation, and are not the wire format.

       Event is one control in the form but two columns in the sheet. When
       "Something else" is chosen the select is disabled and the free-text
       twin carries the value, so the listed type would otherwise be lost:
         picked from the list  ->  type = the choice,      detail = empty
         typed their own       ->  type = "Something else", detail = the text

       Status is sent as "New". The receiving script does not default it — it
       writes whatever it is handed, and a blank when it is handed nothing, so
       omitting it just left the column empty. Every lead arrives marked New
       and the events team moves it on from there; it also matches what the
       other sites already write, and a column where some rows say New and
       others are blank cannot be filtered on. */
    var freeText = evOther && !evOther.disabled;
    var data = {
      'Received':        new Date().toISOString(),
      'Site':            CFG.source || window.location.hostname,
      'Page':            window.location.href,
      'Name':            raw.Name || '',
      'Company':         raw.Company || '',
      'Email':           raw.Email || '',
      'Phone':           raw.Phone || '',
      'Event type':      freeText ? 'Something else' : (raw.Event || ''),
      'Event detail':    freeText ? (raw.Event || '') : '',
      'Guests':          raw.Guests || '',
      'Preferred date':  raw.Date || '',
      'Budget per head': raw.Budget || '',
      'Notes':           raw.Notes || '',
      'Status':          'New'
    };
    return { data: data, raw: raw, text: lines.join('\n') };
  }

  /* There is deliberately no mailto anywhere in this widget. The brief is that
     no email address appears on the site at all, so the phone is the only
     fallback channel: if the POST fails the guest is asked to call rather than
     handed a prefilled email. */
  function showConfirmation(payload, viaEmail) {
    /* read from .raw, not .data — .data is keyed by the sheet's column names */
    var first = String(payload.raw.Name || '').trim().split(/\s+/)[0];
    var guests = payload.raw.Guests || '';
    var pretty = niceDate(payload.raw.Date || '');

    /* the header has to stop selling the form once the form is done */
    root.querySelector('[data-mtitle]').textContent = 'Request received';
    root.querySelector('[data-msub]').textContent = 'One of the events team is already on it.';

    root.querySelector('[data-dtitle]').textContent = first ? 'Thank you, ' + first + '.' : 'Thank you.';
    /* Kept short on purpose: every extra line here pushes the panel past the
       bottom of a laptop window, and this is a receipt, not a pitch. */
    root.querySelector('[data-dlede]').innerHTML =
      'Your request for <b>' + guests + ' guests</b> on <b>' + pretty + '</b> is with our ' +
      'events team. We answer <b>' + CFG.replyPromise + '</b>, and hold the date ' +
      'provisionally in the meantime.';
    root.querySelector('[data-dfine]').textContent = viaEmail
      ? 'If you do not hear from us, call the events line above and we will pick it up from there.'
      : 'A copy of this request is with the events team.';

    form.hidden = true;
    doneEl.hidden = false;
    doneEl.scrollIntoView({ block: 'nearest' });
  }

  /* ── submit ──────────────────────────────────────────────────────────── */
  function fail(msg) { errEl.textContent = msg; errEl.classList.add('on'); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errEl.classList.remove('on');

    fields.forEach(function (f) { f.dataset.touched = '1'; });
    syncAll();

    if (!form.checkValidity()) {
      var bad = form.querySelector('.field.is-invalid input, .field.is-invalid select, .field.is-invalid textarea');
      if (bad) bad.focus({ preventScroll: true });
      return;
    }

    var payload = collect();

    /* No endpoint configured. Nothing can actually be sent, and there is no
       email channel to fall back to, so say so plainly instead of showing a
       confirmation for a request that went nowhere. */
    if (demo) {
      fail('We could not send that from here. Please call us on ' + CFG.phone + ' and we will take the details.');
      return;
    }

    submit.disabled = true;
    submit.querySelector('.lab').textContent = 'Sending…';

    /* Do not make the guest wait out the whole round trip.

       Apps Script is slow to answer: a cold start, then the row write, then
       MailApp.sendEmail — which alone can take ten seconds — and only then the
       302 that fetch has to follow. Blocking the confirmation on all of that
       left the button dead for long enough to look broken.

       The row is appended BEFORE the alert email is attempted, so once the
       request has been on the wire for a moment the lead is stored whatever
       happens to the response. So: confirm at CONFIRM_AFTER regardless, and
       keep the mail fallback only for a failure that lands before then — a
       genuine network error (offline, DNS, blocked) fails fast, well inside
       the window. Yanking someone to their mail client after they have
       already been thanked would be worse than the rare lost alert. */
    var CONFIRM_AFTER = 3000;
    var settled = false;

    function settle(uncertain) {
      if (settled) return;
      settled = true;
      submit.disabled = false;
      submit.querySelector('.lab').textContent = 'Send request';
      showConfirmation(payload, uncertain);
    }

    var timer = setTimeout(function () { settle(false); }, CONFIRM_AFTER);

    fetch(CFG.corporateEndpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload.data)
    }).then(function () {
      clearTimeout(timer);
      settle(false);
    }).catch(function () {
      clearTimeout(timer);
      /* Already confirmed on the timer — the request was on the wire long
         enough that the row is almost certainly stored. Leave it alone. */
      if (settled) return;
      /* Failed fast, so it genuinely did not send. With no email fallback the
         honest thing is to keep the form filled in and point them at the
         phone, rather than thank them for a lead nobody received. */
      submit.disabled = false;
      submit.querySelector('.lab').textContent = 'Send request';
      settled = true;
      fail('That did not send — please check your connection, or call us on ' + CFG.phone + '.');
    });
  });

  /* ── reveal (after the theme's preloader, if there is one) ───────────── */
  function reveal() { host.setAttribute('data-ready', ''); }
  var pre = CFG.waitForPreloader && document.getElementById('preloader');
  if (!pre) {
    reveal();
  } else if (pre.classList.contains('done')) {
    setTimeout(reveal, 300);
  } else {
    var fired = false;
    var go = function () { if (fired) return; fired = true; setTimeout(reveal, 300); };
    var mo = new MutationObserver(function () { if (pre.classList.contains('done')) { mo.disconnect(); go(); } });
    mo.observe(pre, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { mo.disconnect(); go(); }, 7000);
  }
})();
